"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalContextProvider = exports.ModalRootComponent = exports.MODAL_ROOT_ELEMENT_ID = void 0;
const react_1 = __importStar(require("react"));
const libs_hooks_react_1 = require("@hotelplan/libs.hooks-react");
exports.MODAL_ROOT_ELEMENT_ID = `modal-root`;
const ModalContext = react_1.default.createContext(null);
const ModalRootComponent = () => {
    return react_1.default.createElement("div", { id: exports.MODAL_ROOT_ELEMENT_ID });
};
exports.ModalRootComponent = ModalRootComponent;
const ModalContextProvider = ({ children, }) => {
    const [modalRootEl, setModalRootEl] = (0, react_1.useState)(null);
    (0, libs_hooks_react_1.useIsomorphicLayoutEffect)(() => {
        if (document) {
            setModalRootEl(document.getElementById(exports.MODAL_ROOT_ELEMENT_ID));
        }
    }, []);
    return (react_1.default.createElement(ModalContext.Provider, { value: modalRootEl }, children));
};
exports.ModalContextProvider = ModalContextProvider;
if (process.env.NODE_ENV === 'development') {
    ModalContext.displayName = 'ModalContext';
}
exports.default = ModalContext;
//# sourceMappingURL=ModalContext.js.map